import React from "react";
import DataTable, {createTheme} from "react-data-table-component";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";

export default function TableChart(props) {

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };

    const customStyles = {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                backgroundColor: '#FFE600',
                // fontSize: '14px',
                fontWeight: 'bold',
                paddingLeft: '8px',
                paddingRight: '8px',
                justifyContent: 'left',
                wordWrap: 'breakWord',
            },
        },
        pagination: {
            style: {
                border: 'none',
                minHeight: '56px',
                svg: {
                    top: '5px',
                    width: '35px',
                    height: '33px',
                    padding: '3px',
                },
            },
            pageButtonsStyle: {
                height: '40px',
                width: '80px',
                padding: '8px',
                svg: {
                    margin: 'auto',
                    width: '24px',
                    height: '24px',
                },

            },
        },
    };

    createTheme(
        'jumo',
        {
            text: {
                primary: '#ffffff',
                secondary: '#FFE600',
            },
            background: {
                default: '#152065',
            },
            context: {
                background: '#000039',
                text: '#FFFFFF',
            },
            divider: {
                default: '#0074E0',
            },
            button: {
                default: '#FFE600',
                hover: 'rgba(0,0,0,.08)',
                focus: 'rgba(255,255,255,.12)',
                disabled: 'rgba(255, 255, 255, .34)',
            },
            header: {
                style: {
                    fontSize: '22px',
                    color: '#FFE600',
                    backgroundColor: '#152065',
                    minHeight: '56px',
                    paddingLeft: '16px',
                    paddingRight: '8px',
                },
            },
            sortFocus: {
                default: '#2aa198',
            },
        },
        'dark',
    );

    // eslint-disable-next-line
    const ExpandedComponent = ({data}) => <pre>{JSON.stringify(data, null, 2)}</pre>;

    return (

        <DataTable
            {...props}
            noHeader
            pagination
            customStyles={customStyles}
            paginationComponentOptions={paginationComponentOptions}
            highlightOnHover
            theme="jumo"
        />

    );
}